import React, { useState } from 'react';
import './TradeStatsCalculator.css';

export default function TradeStatsCalculator({ items }) {
  const [mode, setMode] = useState('ongoing');
  const [investment, setInvestment] = useState('');
  const [leverage, setLeverage] = useState('');
  const [activeField, setActiveField] = useState('investment'); // 'investment' or 'leverage'
  const [estimatedReturn, setEstimatedReturn] = useState(null);

  const filtered = items.filter(item =>
    mode === 'closed' ? item.closed : !item.closed
  );

  const handleCalculate = () => {
    if (!investment || !leverage) return;
    const capital = parseFloat(investment);
    const lev = parseFloat(leverage);
    let totalReturn = 0;

    filtered.forEach(item => {
      const rec = item.recommendation?.toUpperCase() || "";
      const isLong = rec === "BUY" || rec === "STRONG BUY";
      const entry = isLong ? item.longPosition?.entry : item.shortPosition?.entry;
      const latest = item.latestPrice ?? entry;

      if (entry != null && latest != null) {
        const pl = isLong
          ? ((latest - entry) / entry) * 100
          : ((entry - latest) / entry) * 100;
        totalReturn += capital * lev * (pl / 100);
      }
    });

    setEstimatedReturn(totalReturn.toFixed(2));
  };

  const handleKeyPress = (value) => {
    if (activeField === 'investment') {
      setInvestment(prev => prev + value);
    } else {
      setLeverage(prev => prev + value);
    }
  };

  const handleClear = () => {
    if (activeField === 'investment') setInvestment('');
    else setLeverage('');
  };

  return (
    <div className="trade-calculator-container">
      <div className="trade-calculator-screen">
        <h3>{estimatedReturn !== null ? `$${estimatedReturn}` : 'Results ...'}</h3>
      </div>

      <div className="trade-calculator-panel">
        <div className="trade-calculator-row">
          <label>Mode:</label>
          <select value={mode} onChange={(e) => setMode(e.target.value)}>
            <option value="ongoing">Ongoing</option>
            <option value="closed">Closed</option>
          </select>
        </div>

<div className="trade-calculator-row-main">
  <div className="trade-calculator-row">
    <label>Investment ($):</label>
    <div
      className={`fake-input ${activeField === 'investment' ? 'active' : ''}`}
      onClick={() => setActiveField('investment')}
    >
      {investment || '0'}
    </div>
  </div>

  <div className="trade-calculator-row" style={{ marginLeft: '16px' }}>
    <label>Leverage (x):</label>
    <div
      className={`fake-input ${activeField === 'leverage' ? 'active' : ''}`}
      onClick={() => setActiveField('leverage')}
    >
      {leverage || '0'}
    </div>
  </div>
</div>


        <div className="keypad">
          {[1,2,3,4,5,6,7,8,9,0,'.'].map(key => (
            <button key={key} onClick={() => handleKeyPress(key.toString())}>
              {key}
            </button>
          ))}
          <button onClick={handleClear}>Clear</button>
        </div>

        <button className="trade-calculator-button" onClick={handleCalculate}>
          📊 Calculate Return
        </button>
      </div>
    </div>
  );
}
